import React from "react";
import avatarImage from "../assets/avatar.png";
import { FaLinkedinIn, FaEnvelope, FaFileAlt } from 'react-icons/fa';

// ==========================================
// EDIT YOUR TEXTS AND LINKS HERE
// ==========================================
const HERO_DATA = {
  firstName: "ARINJAY",
  lastName: "CHOUDHURY",
  role: "GAME DESIGNER",

  // Social Links & Buttons
  linkedinUrl: "https://www.linkedin.com/in/arinjayc/",
  linkedinText: "Connect on LinkedIn",

  emailUrl: "mailto:hello@arinjaychoudhury.com?subject=Hi Arinjay! Can we get to know you?",
  emailText: "Email Me",

  resumeUrl: "https://drive.google.com/file/d/1sXSKTuRZ6kaVOh_uFrW776yAn0jHh5nd/view",
  resumeText: "View Resume"
};
// ==========================================

const HeroSection = () => {
  return (
    <>
      <div className="flex flex-col-reverse lg:flex-row justify-around items-center py-4 mt-6 md:mt-24 w-full overflow-hidden px-4">
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left mr-0 lg:mr-8 ml-0 lg:ml-4 mt-8 lg:mt-0" id="hero-section">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-clash-display-bold tracking-tight font-black text-fgPurple text-stroke-sm text-stroke-lg select-none">
            {HERO_DATA.firstName}
          </h1>
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl ml-0 lg:ml-28 font-clash-display-bold tracking-tight font-black text-fgPurple text-stroke-sm text-stroke-lg select-none">
            {HERO_DATA.lastName}
          </h2>
          <h3 className="text-2xl sm:text-3xl md:text-6xl lg:text-8xl mt-4 md:mt-8 font-clash-display-bold tracking-tight font-black text-fgYellow text-drop-shadow text-stroke-sm text-stroke-lg select-none px-4">
            {HERO_DATA.role}
          </h3>
          <div className="flex flex-wrap justify-center lg:justify-start items-center gap-4 mt-8">
            <a
              href={HERO_DATA.linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-2 px-6 h-14 rounded-full bg-[#0A66C2] text-white font-clash-display-semibold text-xl border-2 border-black shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] hover:translate-y-1 hover:shadow-[1px_1px_0px_0px_rgba(0,0,0,1)] transition-all"
            >
              <FaLinkedinIn size={24} />
              <span>{HERO_DATA.linkedinText}</span>
            </a>
            <a
              href={HERO_DATA.emailUrl}
              className="flex items-center justify-center space-x-2 px-6 h-14 rounded-full bg-[#EA4335] text-white font-clash-display-semibold text-xl border-2 border-black shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] hover:translate-y-1 hover:shadow-[1px_1px_0px_0px_rgba(0,0,0,1)] transition-all"
            >
              <FaEnvelope size={24} />
              <span>{HERO_DATA.emailText}</span>
            </a>
            <a
              href={HERO_DATA.resumeUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-2 px-6 h-14 rounded-full bg-fgPurple text-white font-clash-display-semibold text-xl border-2 border-black shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] hover:translate-y-1 hover:shadow-[1px_1px_0px_0px_rgba(0,0,0,1)] transition-all"
            >
              <FaFileAlt size={24} />
              <span>{HERO_DATA.resumeText}</span>
            </a>
          </div>
        </div>
        <div className="w-full md:w-auto mt-8 md:mt-0 flex justify-center md:mr-10">
          <img
            src={avatarImage}
            alt="Hero Image"
            className="w-64 h-64 md:w-80 md:h-80 object-cover rounded-full border-8 border-black shadow-[0px_0px_0px_0px_rgba(0,0,0,1)] bg-white"
          />
        </div>
      </div>
    </>
  );
};

export default HeroSection;
